import { createModal } from '/@/core/elements/modal'

export type InstagramEmailType =
  | 'CLASS_COMPLETION_INSTA'
  | 'PORTFOLIO_INSTA'
  | 'PORTFOLIO_PROJECT_INSTA'
  | 'MOCKUP_INSTA'
  | 'MEMBERSHIP_CARD_INSTA'
  | 'PALETTE_INSTA'

export interface ShareByInstagramModalData {
  emailType: InstagramEmailType | null
  id: string | null
  imageUrl: string | null
  imageExtension: string | null
  downloadTitle: string | null
  onSuccess: (() => void) | null
}

const { api, component } = createModal<ShareByInstagramModalData>(
  'ShareByInstagramModal',
  () => import('./ShareByInstagramModal.vue'),
  {
    emailType: null,
    id: null,
    imageUrl: null,
    imageExtension: null,
    downloadTitle: null,
    onSuccess: null,
  },
)

export const useShareByInstagramModal = api
export default component
